import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { connect } from "react-redux";
import Time from "../../../Time/Time";
import { AddressSelector } from "../../Partials/AddressSelector/AddressSelector";
import { Attachment } from "../../Partials/Attachment/Attachment";
import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";
import { DatePickerComponent } from "../../Partials/DatePicker/DatePickerComponent";
import { Admin } from "../../../Entity/Entities/Person/Role/Roles/Admin";
import { User } from "../../../Entity/Entities/Person/Role/Roles/User";
import { Timeline } from "../../Partials/Timeline/Timeline";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { ContractInterface } from "../../../Entity/Entities/Contract/ContractInterface";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import PersonUpdateWillMount from "../../../Middleware/Middlewares/PersonUpdateWillMount";
import PreventPageLeave from "../../../Middleware/Middlewares/PreventPageLeave";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Select from "../../Partials/Material/Select";
import Card from '@material-ui/core/Card';
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
import { EventInterface } from "../../../Entity/Entities/Event/EventInterface";
import { EntityAvatar } from "../../Partials/Avatar/EntityAvatar";
import Checkbox from '@material-ui/core/Checkbox';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PersonCard from "../../Partials/Person/PersonCard";

class PersonUpdate extends Component {
  public state = {
    person: null,
    currentUser: null,
    avatar: null,
    id: null,
    firstName: null,
    lastName: null,
    email: "",
    role: String(User.contactRoleId),
    phone1: null,
    phone2: null,
    profession: null,
    mainBankAccountId: null,
    mainBankAccountName: null,
    personAddress: {
      formattedAddress: ""
    },
    dateOfBirth: null,
    identityNumber: null,
    identityType: 255,
    amazonFolderName: null,
    openLeavePrompt: false,
    note: "",
    hasModifiedData: false,
    isNotEditable: false,
    displayLess: true,
    displayMore: false,
    events: [],
    tasks: [],
    fetchingEvents: true,
    fetchingTasks: true,
    isSaving: false,
    genderTypeId: 3,
    languageTypeId: this.props.app.settings.agency?.defaultLanguage?.iso === 'en-US' ? 1 : 2,

    attachments: [],
    documentAddress: {
      formattedAddress: "",
    },
    removed: false,
    beta: false,
    anchorUserEl: null,
    isDeleteUserPopupOpen: false,
    placeOfBirthAddress: {
      formattedAddress: "",
    },
    nextPath: "",
    newEmail: "",
    confirmEmail: "",
    confirmEmailNotValid: false,
    errorChangeEmailId: "",
  };

  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.PAGE_CONTACT_PERSON_UPDATE_CLEAR;
  protected middlewares: MiddlewareInterface[] = [
    PersonUpdateWillMount,
    PreventPageLeave
  ];

  constructor(public props) {
    super(props);

    this.save = this.save.bind(this);
    this.done = this.done.bind(this);
  }

  public initializePage = (person: PersonInterface) => {
    if (!person) {
      return this.redirectBack();
    }

    if(person?.documentAddress?.formattedAddress){
      this.setState({
        documentAddress: person.documentAddress
      })
    }


    this.props.dispatch({
      type: Constants.PAGE_CONTACT_PERSON_UPDATE_CLEAR
    });

    this.fetchEntityEvents(person.id);

    const currentUser = this.props.app.persons.filter(
      person => person.id === this.props.app.session.user.id
    )[0];

    let isNotEditable = false;

    if ((currentUser && currentUser.role && currentUser.role.getRoleId() !== Admin.contactRoleId) || person.removed) {
      isNotEditable = true;
    }

    this.setState({
      person: person,
      currentUser: currentUser,
      id: person.id,
      amazonFolderName: person.amazonFolderName,
      note: person.note,
      firstName: person.firstName,
      lastName: person.lastName,
      email: person.email,
      role: person.role ? String(person.role.getRoleId()) : "",
      phone1: person.phone1,
      phone2: person.phone2,
      profession: person.profession,
      mainBankAccountId: person.mainBankAccountId,
      mainBankAccountName: person.mainBankAccountName,
      personAddress: person.address,
      attachments: person.attachments,
      dateOfBirth: person.dateOfBirth,
      placeOfBirthAddress: person.placeOfBirthAddress,
      identityNumber: person.identityNumber,
      identityType: person.identityType,
      isNotEditable: isNotEditable,
      genderTypeId: person.genderTypeId,
      languageTypeId: person.languageTypeId,
      removed: person.removed,
      beta: !!person && person.userSettings && person.userSettings.beta
    });
  }

  public componentWillReceiveProps(nextProps) {
    const prevId = parseInt(this.props.params.id, 10);
    const id = parseInt(nextProps.params.id, 10);
    const person: PersonInterface = nextProps.app.persons.filter((person: PersonInterface) => person.id === id)[0];

    if (prevId !== id) {
      this.initializePage(person);
    } else {
      this.setState({
        // beta: !!person && person.userSettings && person.userSettings.beta,
        person: person,
        attachments: !!person ? person.attachments : []
      });
    }
  }

  public fetchEntityEvents = (entityId: number) => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        contactId: entityId
      },
      onSuccess: data => {
        const contactEvents: EventInterface[] = data.events
          .filter((event: EventInterface) => !event.removed);
        this.setState({
          events: [...contactEvents],
          fetchingEvents: false
        });
      }
    });
  }
  
  public deleteContract(contract: ContractInterface): any {
    this.props.dispatch({
      type: Constants.GLOBAL_CONTRACT_DELETE_START,
      payload: {
        contract: contract
      }
    });
  }

  public done(): void {
    this.redirectBack();
  }

  public save() {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_CONTACT_PERSON_UPDATE_START,
        payload: {
          id: this.state.id,
          isFromDialog: false,
          person: {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            profession: this.state.profession,
            mainBankAccountId: this.state.mainBankAccountId,
            mainBankAccountName: this.state.mainBankAccountName,
            bankAccount: {
              accountId: this.state.mainBankAccountId,
              name: this.state.mainBankAccountName
            },
            phone1: this.state.phone1,
            phone2: this.state.phone2,
            contactRoleId: Number(this.state.role),
            dateOfBirth: Time.formatOrNull(this.state.dateOfBirth),
            placeOfBirth: this.state.placeOfBirthAddress,
            identityNumber: this.state.identityNumber,
            identityType: this.state.identityType,
            address: {
              ...this.state.personAddress
            },
            note: this.state.note,
            genderTypeId: this.state.genderTypeId,
            languageTypeId: this.state.languageTypeId,
            documentAddress: this.state.documentAddress,
            email: this.state.email
          },
          previousCompanyId: this.state.person && this.state.person.companyId
        },
        onSuccess: () => {
          return this.redirectBack();
        },
        onError: () => {
          this.setState({
            isSaving: false,
            hasModifiedData: true
          });
        }
      });
    });
  }

  public changeRole = (event) => {
    const role = String(event.target.value);

    this.setState({
      role: role,
      hasModifiedData: true
    });
  }

  public selectCountry = (event) => {
    this.setState({
      hasModifiedData: true,
      documentAddress: event,
    })
  }

  public clearCountry = () => {
    this.setState({
      hasModifiedData: true,
      documentAddress: {
        formattedAddress: "",
      }
    })
  }

  public setEmail = (event) => {
    const email = event.target.value;

    this.setState({
      email: email,
      hasModifiedData: true
    });
  }

  public selectPlaceOfBirth = (event) => {
    this.setState({
      hasModifiedData: true,
      placeOfBirthAddress: event,
    })
  }

  public clearPlaceOfBirth = () => {
    this.setState({
      hasModifiedData: true,
      placeOfBirthAddress: {
        formattedAddress: "",
      }
    })
  }

  public switchUsingBeta = () => {
    this.setState({
      beta: !this.state.beta
    }, () => {
      this.saving(() => {
        this.props.dispatch({
          type: Constants.PAGE_SETTINGS_PREFERENCES_UPDATE_START,
          payload: {
            preferences: {
              language: this.state.person &&
                        this.state.person.userSettings &&
                        this.state.person.userSettings.language &&
                        this.state.person.userSettings.language.iso,
              locale:   this.state.person &&
                        this.state.person.userSettings &&
                        this.state.person.userSettings.locale &&
                        this.state.person.userSettings.locale.iso,
              currency: this.state.person &&
                        this.state.person.userSettings &&
                        this.state.person.userSettings.currency &&
                        this.state.person.userSettings.currency.getCurrencyId(),
              beta: this.state.beta,
              userId: this.state.person && this.state.person.id,
            }
          },
          onSuccess: () => {
            this.setState({
              isSaving: false,
              hasModifiedData: false
            });
          },
          onError: () => {
            this.setState({
              isSaving: false,
              hasModifiedData: true
            });
          }
        });
      });
    });
  }

     /* START Methods for 3-dot menu */

     protected openUserMenu = (event: any): void => {
      this.setState({
        anchorUserEl: event.currentTarget
      });
    }
  
    protected closeUserMenu = (): void => {
      this.setState({
        anchorUserEl: null
      });
    }
  
    protected openDeletePromptDialog = (): void => {
      this.setState({
        isDeleteUserPopupOpen: true,
        anchorUserEl: null
      });
    }
  
    public closeDeletePrompt = (): void => {
      this.setState({
        isDeletePromptOpen: false,
        anchorUserEl: null
      });
    }
  
    public deletePerson = () => {
      this.closeDeletePrompt();
      return this.props.dispatch({
        type: Constants.GLOBAL_PERSON_DELETE_START,
        payload: {
          person: this.state.person
        },
        onSuccess: () => {
          this.redirectBack();
        }
      });
    }

    /* FINISH Methods for 3-dot menu */
  
  public setConfirmEmail = (event) => {
    const confirmEmail = event.target.value;

    this.setState({
      confirmEmail: confirmEmail,
      confirmEmailNotValid: false
    });
  }

  public changeEmail  = () => {
    if (!this.state.newEmail || !this.state.confirmEmail || this.state.newEmail !== this.state.confirmEmail) {
      return this.setState({
        confirmEmailNotValid: true
      });
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_SETTINGS_USER_PROFILE_CHANGE_EMAIL_START,
        payload: {
          data: {
            newEmail: this.state.newEmail,
            userId: this.state.person?.id,
          }
        },
        onSuccess: () => {
          this.setState({
            isSaving: false,
            newEmail: "",
            confirmEmail: ""
          }, () => {
            if (this.state.nextPath) {
              return this.redirect(this.state.nextPath);
            }
          });
        },
        onError: (err) => {
          this.setState({
            isSaving: false,
            hasModifiedData: true,
            errorChangeEmailId: err?.errorId
          });
        }
      });
    });
  }

  public resendInvite = () => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_CONFIRM_RESEND_INVITE_EMAIL_REQUEST,
        payload: {
          data: this.state.person
        },
        onSuccess: () => {
          this.props.dispatch({
            type: Constants.SNACKBAR_ADD_MESSAGE,
            payload: {
              message: this.trans("invitation-email-sent"),
              type: "success"
            }
          });

          this.setState({isSaving: false})
        },
        onError: () => this.setState({isSaving: false}),
      });
    });
  }

  public render() {
    const radioButtonStyles = {
      width: "auto",
      marginRight: "0",
      minWidth: "155px"
    };

    return (
      <div className="state-app">
        <div className="box box-full has-details-page-header">
          <div className="component-header has-back-button">
            <div className="inner-wrapper">
              <div className="back-arrow-wrapper" onClick={this.redirectBack}>
                <div className="icon icon-ic-arrow-back icon-color"></div>
              </div>
              <div className="title-wrapper">
                <h1>{this.trans("role-user")} {this.state.person && this.state.person.firstName} {this.state.person && this.state.person.lastName + " - "}
                <span style={{color: this.state.person && this.state.person.getConfirmationStatusColor()}}>{this.state.person && this.state.person.getConfirmationStatus()}</span></h1>
              </div>
              <div className="button-container">
                {
                  this.state.hasModifiedData && (
                    <Button
                      color="primary"
                      onClick={this.redirectBack}
                      style={{marginRight: "20px"}}
                    >
                      {this.trans("button-cancel")}
                    </Button>
                  )
                }
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.state.hasModifiedData ? this.save : this.redirectBack}
                  disabled={this.state.isSaving}
                >
                  {this.state.hasModifiedData ? this.trans("button-save") : this.trans("label-done")}
                </Button>
              </div>
              <div className="three-dot-entity-menu">
                <IconButton
                  onClick={e => this.openUserMenu(e)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorUserEl}
                  open={Boolean(this.state.anchorUserEl)}
                  onClose={this.closeUserMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    className="delete-action"
                    onClick={this.openDeletePromptDialog}
                  >
                    <ListItemIcon><div className="icon icon-ic-remove aligned"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            </div>
          </div>
          <div>
            <div className="box component-person-update">
              <div className="component-wrapper no-margin-top">
                <div className="component">
                  <PersonCard
                    {...this.props}
                    user={true}
                    mainCardPresentation={true}
                    person={this.state.person}
                    editableFields={
                      <>
                      <div className="row align-center-icon" style={{marginBottom: "-10px"}}>
                        <div className="grid align-icon-grid">
                          <EntityAvatar
                            {...this.props}
                            ref="EntityAvatar"
                            entityName="person"
                          />
                        </div>
                        <div className="grid">
                          <TextField
                            autoComplete="off"
                            className="form-element full-size scroll-to-firstName"
                            type="text"
                            label={this.trans("label-first-name")}
                            value={this.state.firstName}
                            onChange={this.sync.bind(this, this.syncronizers.EVENT, "firstName")}
                            autoFocus={true}
                            disabled={this.state.isNotEditable}
                            variant="standard"
                            error={!!this.getErrorFor("firstName")}
                          />
                          {!!this.getErrorFor("firstName") && <div className="component-error-text">{this.getErrorFor("firstName")}</div>}
                        </div>
                      </div>
              
                      <div className="row">
                        <div className="grid"></div>
                        <div className="grid">
                          <form>
                            <TextField
                              autoComplete="off"
                              className={this.state.isNotEditable ? "form-element full-size no-border scroll-to-lastName" : "form-element full-size scroll-to-lastName"}
                              type="text"
                              label={this.trans("label-last-name") + this.trans("field/optional")}
                              value={this.state.lastName}
                              onChange={this.sync.bind(this, this.syncronizers.EVENT, "lastName")}
                              disabled={this.state.isNotEditable}
                              variant="standard"
                              error={!!this.getErrorFor("lastName")}
                            />
                            {!!this.getErrorFor("lastName") && <div className="component-error-text">{this.getErrorFor("lastName")}</div>}
              
                            <div style={{display: "flex", justifyContent: "flex-start", alignItems: "center"}}>
                              <TextField
                                autoComplete="off"
                                className="form-element full-size scroll-to-email"
                                label={this.trans("label-email")}
                                value={this.state.email}
                                onChange={this.setEmail}
                                variant="standard"
                                disabled={true}
                                error={!!this.getErrorFor("email")}
                              />
                              {!!this.getErrorFor("email") && <div className="component-error-text">{this.getErrorFor("email")}</div>}
              
                              {
                                !this.state.person?.isAccountConfirmed &&
                                <Button
                                  color="primary"
                                  onClick={this.resendInvite}
                                  style={{marginLeft: "20px", color: "#00BCD4", border: "1px solid rgba(0, 0, 0, 0.1)"}}
                                >
                                  {this.trans("button-send-invite-mail")}
                                </Button>
                              }
                            </div>
              
                            <div className="filters-wrapper" style={{
                              display: "flex"
                            }}>
                              <RadioGroup
                                name="roleFilters"
                                value={String(this.state.role)}
                                onChange={this.changeRole}
                                style={{
                                  display: "flex",
                                  flexDirection: "row"
                                }}
                              >
                                <FormControlLabel
                                  value={String(User.contactRoleId)}
                                  label={this.trans("role-manager")}
                                  style={radioButtonStyles}
                                  control={<Radio color="primary" />}
                                  disabled={this.state.currentUser && this.state.currentUser.role.getRoleId() === User.contactRoleId}
                                />
                                <FormControlLabel
                                  value={String(Admin.contactRoleId)}
                                  label={this.trans("role-admin")}
                                  style={radioButtonStyles}
                                  control={<Radio color="primary" />}
                                  disabled={this.state.currentUser && this.state.currentUser.role.getRoleId() === User.contactRoleId}
                                />
                              </RadioGroup>
                            </div>
                            {!!this.getErrorFor("contactRoleId") && <div className="component-error-text" style={{marginTop: "3px"}}>{this.getErrorFor("contactRoleId")}</div>}
              
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={this.state.beta}
                                  onChange={this.switchUsingBeta}
                                  color="primary"
                                  disabled={this.state.isNotEditable}
                                />
                              }
                              label={this.trans("use-beta-version-features")}
                            />
              
                            <div style={{margin: "-10px 0"}}>
                              <TextField
                                autoComplete="off"
                                className={this.state.isNotEditable ? "form-element half-size no-border scroll-to-phone1" : "form-element half-size scroll-to-phone1"}
                                type="text"
                                label={this.trans("label-mob-number") + this.trans("field/optional")}
                                value={this.state.phone1}
                                onChange={this.sync.bind(this, this.syncronizers.EVENT, "phone1")}
                                disabled={this.state.isNotEditable}
                                variant="standard"
                                error={!!this.getErrorFor("phone1")}
                              />
                              {!!this.getErrorFor("phone1") && <div className="component-error-text">{this.getErrorFor("phone2")}</div>}
              
                              <TextField
                                autoComplete="off"
                                className={this.state.isNotEditable ? "form-element half-size no-border scroll-to-phone2" : "form-element half-size scroll-to-phone2"}
                                type="text"
                                label={this.trans("other-phone") + this.trans("field/optional")}
                                value={this.state.phone2}
                                onChange={this.sync.bind(this, this.syncronizers.EVENT, "phone2")}
                                disabled={this.state.isNotEditable}
                                variant="standard"
                                error={!!this.getErrorFor("phone2")}
                              />
                              {!!this.getErrorFor("phone2") && <div className="component-error-text">{this.getErrorFor("phone2")}</div>}
                            </div>
              
                            {this.state.displayLess && (
                              <Button
                                color="primary"
                                onClick={() => this.setState({displayMore: true, displayLess: false})}
                                style={{width: "100%", margin: "10px 0 10px 0"}}
                              >
                                {this.trans("button-show-more")}
                              </Button>
                            )}
              
                            {this.state.displayMore && (
                              <div>
                                <Select
                                  className="form-element full-size form-input scroll-to-genderTypeId correct-label-position"
                                  variant="standard"
                                  error={this.getErrorFor("genderTypeId")}
                                  disabled={this.state.isNotEditable}
                                  value={this.state.genderTypeId}
                                  onChange={this.sync.bind(this, this.syncronizers.GENDER_TYPE)}
                                  htmlFor="genderType"
                                  label={this.trans("gender-type") + this.trans("field/optional")}
                                  name="genderType" 
                                  id="genderType"
                                >
                                  {this.getGenderTypeSelectboxes()}
                                </Select>
              
                                <Select
                                  className="form-element full-size form-input scroll-to-languageTypeId correct-label-position"
                                  variant="standard"
                                  error={this.getErrorFor("languageTypeId")}
                                  disabled={this.state.isNotEditable}
                                  value={this.state.languageTypeId}
                                  onChange={this.sync.bind(this, this.syncronizers.LANGUAGE_TYPE)}
                                  htmlFor="languageType"
                                  label={this.trans("language-type") + this.trans("field/optional")}
                                  name="languageType" 
                                  id="languageType"
                                >
                                  {this.getLanguageTypeSelectboxes()}
                                </Select>
              
                                <TextField
                                  autoComplete="off"
                                  className={this.state.isNotEditable ? "form-element full-size no-border scroll-to-profession" : "form-element full-size scroll-to-profession"}
                                  type="text"
                                  label={this.trans("profession") + this.trans("field/optional")}
                                  value={this.state.profession}
                                  onChange={this.sync.bind(this, this.syncronizers.EVENT, "profession")}
                                  disabled={this.state.isNotEditable}
                                  variant="standard"
                                  error={!!this.getErrorFor("profession")}
                                />
                                {!!this.getErrorFor("profession") && <div className="component-error-text">{this.getErrorFor("profession")}</div>}
              
                                <DatePickerComponent
                                  {...this.props}
                                  className="no-border scroll-to-dateOfBirth"
                                  label={this.trans("date-of-birth") + this.trans("field/optional")}
                                  initialDate={this.state.dateOfBirth}
                                  onChange={date => this.setState({ dateOfBirth: date, hasModifiedData: true })}
                                  disabled={this.state.isNotEditable}
                                  clearButton={true}
                                  error={this.getErrorFor("dateOfBirth")}
                                />
              
                                <AddressSelector
                                  {...this.props}
                                  className="scroll-to-documentAddress"
                                  labelText={this.trans("place-of-birth") + this.trans("field/optional")}
                                  searchText={this.state.placeOfBirthAddress.formattedAddress ? this.state.placeOfBirthAddress.formattedAddress : null}
                                  selectedAddress={this.state.placeOfBirthAddress}
                                  onSelect={this.selectPlaceOfBirth}
                                  onClear={this.clearPlaceOfBirth}
                                  error={this.getErrorFor("placeOfBirth")}
                                />
              
                                <Select
                                  className="form-element full-size form-input scroll-to-identityType correct-label-position"
                                  variant="standard"
                                  error={this.getErrorFor("identityType")}
                                  disabled={this.state.isNotEditable}
                                  value={this.state.identityType}
                                  onChange={this.sync.bind(this, this.syncronizers.IDENTITY_TYPE)}
                                  htmlFor="identityDocumentType"
                                  label={this.trans("identity-document-type") + this.trans("field/optional")}
                                  name="identityDocumentType" 
                                  id="identityDocumentType"
                                >
                                  {
                                    !this.state.identityType && (
                                      <MenuItem key={"identity-type-none"} value={0} className="identity-type-el">{this.trans("label-none")}</MenuItem>
                                    )
                                  }
                                  {this.getIdentityTypeSelectboxes()}
                                </Select>
              
                                <TextField
                                  autoComplete="off"
                                  className={this.state.isNotEditable ? "form-element full-size no-border scroll-to-identityNumber" : "form-element full-size scroll-to-identityNumber"}
                                  type="text"
                                  label={this.trans("identity-document-number") + this.trans("field/optional")}
                                  value={this.state.identityNumber}
                                  onChange={this.sync.bind(this, this.syncronizers.EVENT, "identityNumber")}
                                  disabled={this.state.isNotEditable}
                                  variant="standard"
                                  error={!!this.getErrorFor("identityNumber")}
                                />
                                {!!this.getErrorFor("identityNumber") && <div className="component-error-text">{this.getErrorFor("identityNumber")}</div>}
              
                                <AddressSelector
                                  {...this.props}
                                  className="scroll-to-documentAddress"
                                  labelText={this.trans("dropdown/documentcountry-label") + this.trans("field/optional")}
                                  searchText={this.state.documentAddress.formattedAddress ? this.state.documentAddress.formattedAddress : null}
                                  selectedAddress={this.state.documentAddress}
                                  onSelect={this.selectCountry}
                                  onClear={this.clearCountry}
                                  countryList={true}
                                />
              
                                <AddressSelector
                                  {...this.props}
                                  name="address.googlePlaceId"
                                  className="no-border scroll-to-address"
                                  searchText={this.state.personAddress.formattedAddress ? this.state.personAddress.formattedAddress : null}
                                  selectedAddress={this.state.personAddress}
                                  onSelect={this.sync.bind(this, this.syncronizers.VALUE, "personAddress")}
                                  onClear={this.sync.bind(this, this.syncronizers.VALUE, "personAddress", {})}
                                  disabled={this.state.isNotEditable}
                                />
              
                                <TextField
                                  autoComplete="off"
                                  className={this.state.isNotEditable ? "form-element full-size no-border scroll-to-mainBankAccountId" : "form-element full-size scroll-to-mainBankAccountId"}
                                  type="text"
                                  label={this.trans("label-bank-account-id") + this.trans("field/optional")}
                                  value={this.state.mainBankAccountId}
                                  onChange={this.sync.bind(this, this.syncronizers.EVENT, "mainBankAccountId")}
                                  disabled={this.state.isNotEditable}
                                  variant="standard"
                                  error={!!this.getErrorFor("bankAccount.accountId")}
                                  helperText={this.getErrorFor("bankAccount.accountId")}
                                />
              
                                <TextField
                                  autoComplete="off"
                                  className="form-element full-size scroll-to-mainBankAccountName"
                                  type="text"
                                  label={this.trans("label-bank-account-name") + this.trans("field/optional")}
                                  value={this.state.mainBankAccountName}
                                  onChange={this.sync.bind(this, this.syncronizers.EVENT, "mainBankAccountName")}
                                  variant="standard"
                                  error={!!this.getErrorFor("mainBankAccountName")}
                                  helperText={this.getErrorFor("mainBankAccountName")}
                                /> 
              
                                <TextField
                                  autoComplete="off"
                                  className={this.state.isNotEditable ? "form-element full-size no-border scroll-to-note" : "form-element full-size scroll-to-note"}
                                  type="text"
                                  multiline={true}
                                  rowsMax={10}
                                  label={this.trans("note") + this.trans("field/optional")}
                                  value={this.state.note}
                                  onChange={this.sync.bind(this, this.syncronizers.EVENT, "note")}
                                  disabled={this.state.isNotEditable}
                                  variant="standard"
                                  error={!!this.getErrorFor("note")}
                                />
                                {!!this.getErrorFor("note") && <div className="component-error-text">{this.getErrorFor("note")}</div>}
              
                                <Button
                                  color="primary"
                                  onClick={() => this.setState({displayMore: false, displayLess: true})}
                                  style={{width: "100%", margin: "10px 0 10px 0"}}
                                >
                                  {this.trans("button-show-less")}
                                </Button>
                              </div>
                            )}
                          </form>
                        </div>
                      </div>
                    </>
                    }
                  />
                </div>
              </div>

              {
                this.state.person?.isAccountConfirmed &&
                <div className="component-wrapper">
                  <Card className="card no-padding">
                    <div className="label-container">
                      <h3 className="card-title">
                        {this.trans("change-email")}
                      </h3>
                    </div>

                    <div className="row">
                      <div className="grid"></div>
                      <div className="grid">
                        <form>
                          {
                            this.state.person?.newEmail && (
                            <div style={{display: "flex", alignItems: "flex-start", justifyContent: "flex-start", color: "green", fontSize: "12px", margin: "10px 0 20px 10px"}}>
                              <div className="icon icon-ic-check-circle" style={{color: "green", marginRight: "10px"}}></div>
                              <div>{this.trans("verification-email-sent", {currentEmail: this.state.person?.email, newEmail: this.state.person?.newEmail})}</div>
                            </div>
                          )}
                          <TextField
                            autoComplete="off"
                            className="form-element full-size scroll-to-email"
                            label={this.trans("current-label-email")}
                            value={this.state.email}
                            onChange={(event) => {
                              const email = event.target.value;
                          
                              this.setState({
                                email: email
                              });
                            }}
                            variant="standard"
                            disabled={true}
                            error={!!this.getErrorFor("email")}
                          />
                          {!!this.getErrorFor("email") && <div className="component-error-text">{this.getErrorFor("email")}</div>}
                          <TextField
                            autoComplete="off"
                            className="form-element full-size"
                            label={this.trans("new-email")}
                            value={this.state.newEmail}
                            onChange={(event) => {
                              const newEmail = event.target.value;
                          
                              this.setState({
                                newEmail: newEmail
                              });
                            }}
                            variant="standard"
                            error={(this.state.confirmEmailNotValid && !!this.trans("confirm-email-should-be-equal")) || !!this.getErrorFor("newEmail") || this.state.errorChangeEmailId}
                          />
                          {this.state.confirmEmailNotValid ? <div className="component-error-text">{this.trans("confirm-email-should-be-equal")}</div>
                          :
                          this.state.errorChangeEmailId && <div className="component-error-text">{this.trans(this.state.errorChangeEmailId)}</div>
                          }
                          <TextField
                            autoComplete="off"
                            className="form-element full-size"
                            label={this.trans("confirm-email")}
                            value={this.state.confirmEmail}
                            onChange={this.setConfirmEmail}
                            variant="standard"
                            error={(this.state.confirmEmailNotValid && !!this.trans("confirm-email-should-be-equal")) || !!this.getErrorFor("newEmail") || this.state.errorChangeEmailId}
                          />
                          {this.state.confirmEmailNotValid ? <div className="component-error-text">{this.trans("confirm-email-should-be-equal")}</div>
                          :
                          this.state.errorChangeEmailId && <div className="component-error-text">{this.trans(this.state.errorChangeEmailId)}</div>
                          }
                        </form>
                        <Button
                          variant="contained"
                          color="primary"
                          className="form-button"
                          onClick={this.changeEmail}
                          style={{margin: "10px 0"}}
                        >
                          {this.trans("button-save")}
                        </Button>
                      </div>
                    </div>  
                  </Card>
                </div>
              }

              {
                !this.state.isNotEditable && (
                  <div className="component-wrapper">
                    <Attachment
                      {...this.props}
                      typeOfComponent="shared"
                      possibilityToSetAvatar={true}
                      title={this.trans("attachments-for-user")}
                      amazonFolderName={this.state.amazonFolderName}
                      relation="contactId"
                      entity={this.state.person}
                      attachments={this.state.attachments}
                      updateParentState={attachments => this.setState({attachments: attachments})}
                      onChangeAvatar={avatar => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).change(avatar)}
                      onLastImageDeleted={() => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).revert()}
                      disabled={this.state.isNotEditable}
                    />
                  </div>
                )
              }
            </div>

            { this.isBeta() && 
              <Timeline
                {...this.props}
                relations={{ contactId: this.state.person && this.state.person.id }}
                entityEvents={this.state.events}
                fetchEntityEvents={this.fetchEntityEvents.bind(this, this.state.person && this.state.person.id)}
                fetchingEvents={this.state.fetchingEvents}
              />
            }
          </div>
        </div>

        <PromptDialog
          {...this.props}
          title={this.trans("delete-user")}
          content={this.trans("you-are-about-to-delete-user",
            {
              role: this.state.person && this.state.person.role ? this.state.person.role.getName() : "",
              name: this.state.person ? `${this.state.person.firstName} ${this.state.person.lastName}` : ""
            })
          }
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("button-remove")}
          openLeavePrompt={this.state.isDeleteUserPopupOpen}
          prioritizeClosing={true}
          onDiscard={() => { this.setState({ isDeleteUserPopupOpen: false }); }}
          onSave={() => { this.setState({ isDeleteUserPopupOpen: false }, this.deletePerson )}}
          positiveButtonStyle={{backgroundColor:"red"}}
          hideCross={true}
        />

        <LeavePromptDialog
          {...this.props}
          prioritizeClosing={true}
          onClose={() => this.setState({ openLeavePrompt: false, nextPath: "" })}
          openLeavePrompt={this.state.openLeavePrompt}
          onDiscard={this.leave.bind(this)}
          onSave={() => { this.setState({ openLeavePrompt: false }); this.save(); }}
          hideCross={true}
          leavePrompt={true}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    charges: state.charges,
    units: state.units,
    component: state.personUpdate,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  PersonUpdate
);
